import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASEURL_POLYMER, SUB_PATH_BASIC } from "../../utils/api";
import { ConsentApplication } from "../../models/polymer/ConsentApplication.model";

interface QueryParams {
  uinfin: string;
  singpass_token: string;
  applicationUuid: string;
}

export const applicationConsentApi  = createApi({
  reducerPath: "applicationConsentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "GET");
      headers.set("X-Content-Type-Options", "nosniff");
    },
  }),
  endpoints: (builder) => ({
    getApplicationConsentByUuid: builder.query<ConsentApplication, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url: `${SUB_PATH_BASIC}/checkApplicationConsent?applicationUuid=${queryParams.applicationUuid}`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`,
        },
      }),
      transformResponse:(response: ConsentApplication, meta, arg)=>{
        return response;
      }
    }),
  }),
});

export const { useGetApplicationConsentByUuidQuery } = applicationConsentApi;
